import {flow} from 'lodash';
//@ts-ignore
import ReactMarkdown from 'react-markdown';
import 'katex/dist/katex.min.css';
//@ts-ignore
import RemarkMath from 'remark-math';
//@ts-ignore
import RemarkBreaks from 'remark-breaks';
//@ts-ignore
import RehypeKatex from 'rehype-katex';
//@ts-ignore
import RemarkGfm from 'remark-gfm';
//@ts-ignore
import RehypeRaw from 'rehype-raw';
import ThinkBlock from './think-block';
import ScriptBlock from "./script";
import Link from "./link";
import Img from "./img";
import cn from '../../utils/classnames';
import './markdown.scss';

const preprocessLaTeX = (content: string) => {
    //@ts-ignore
    if (typeof content !== 'string') return content;
    const codeBlockRegex = /```[\s\S]*?```/g;
    const codeBlocks = content.match(codeBlockRegex) || [];
    let processedContent = content.replace(codeBlockRegex, 'CODE_BLOCK_PLACEHOLDER');
    processedContent = flow([
        (str: string) => str.replace(/\\\[(.*?)\\\]/g, (_, equation) => `$$${equation}$$`),
        (str: string) => str.replace(/\\\[(.*?)\\\]/gs, (_, equation) => `$$${equation}$$`),
        (str: string) => str.replace(/\\\((.*?)\\\)/g, (_, equation) => `$$${equation}$$`),
        (str: string) => str.replace(/(^|[^\\])\$(.+?)\$/g, (_, prefix, equation) => `${prefix}$${equation}$`),
    ])(processedContent);

    codeBlocks.forEach((block) => {
        processedContent = processedContent.replace('CODE_BLOCK_PLACEHOLDER', block)
    });

    return processedContent;
}

const preprocessThinkTag = (content: string) => {
    const thinkOpenTagRegex = /<think>\n/g
    const thinkCloseTagRegex = /\n<\/think>/g
    return flow([
        (str: string) => str.replace(thinkOpenTagRegex, '<details data-think=true>\n'),
        (str: string) => str.replace(thinkCloseTagRegex, '\n[ENDTHINKFLAG]</details>'),
    ])(content)
}
const Paragraph = (paragraph: any) => {
    const {node}: any = paragraph
    const children_node = node.children
    if (children_node && children_node[0] && 'tagName' in children_node[0] && children_node[0].tagName === 'img') {
        return (
            <div className="markdown-img-wrapper">
                {
                    //@ts-ignore
                    <img src={[children_node[0].properties.src]} alt={''}/>
                }
                {
                    Array.isArray(paragraph.children) && paragraph.children.length > 1 && (
                        <div className="mt-2">{paragraph.children.slice(1)}</div>
                    )
                }
            </div>
        )
    }
    return <p>{paragraph.children}</p>
}


export function markdown(props: { content: string; className?: string; customDisallowedElements?: string[] }) {
    const latexContent = flow([
        preprocessThinkTag,
        preprocessLaTeX,
    ])(props.content)

    return (
        <div className={cn('markdown-body', '!text-text-primary', props.className)}>
            <ReactMarkdown
                remarkPlugins={[
                    RemarkGfm,
                    [RemarkMath, {singleDollarTextMath: false}],
                    RemarkBreaks,
                ]}
                rehypePlugins={[
                    RehypeKatex,
                    RehypeRaw as any,
                    // The Rehype plug-in is used to remove the ref attribute of an element
                    () => {
                        return (tree: any) => {
                            const iterate = (node: any) => {
                                if (node.type === 'element' && node.properties?.ref)
                                    delete node.properties.ref

                                if (node.type === 'element' && !/^[a-z][a-z0-9]*$/i.test(node.tagName)) {
                                    node.type = 'text'
                                    node.value = `<${node.tagName}`
                                }

                                if (node.children)
                                    node.children.forEach(iterate)
                            }
                            tree.children.forEach(iterate)
                        }
                    },
                ]}
                disallowedElements={['iframe', 'head', 'html', 'meta', 'link', 'style', 'body', ...(props.customDisallowedElements || [])]}
                components={{
                    //@ts-ignore
                    img: Img,
                    a: Link,
                    p: Paragraph,
                    script: ScriptBlock as any,
                    details: ThinkBlock,
                }}
            >
                {/* Markdown detect has problem. */}
                {latexContent}
            </ReactMarkdown>
        </div>
    )
}
